function passwordAnalyzer(
  password,
  rules
) {
  let rulesResults = rules.map(rule => rule.test({password: password}));
  let isValid = rulesResults.every(x => x.pass);
  let len = password ? password.length : 0;

  let strengthScore;
  if (len === 0) {
    strengthScore = 0;
  } else if (!isValid || len < 8) {
    strengthScore = 1;
  } else if (len < 10) {
    strengthScore = 2;
  } else if (len < 12) {
    strengthScore = 3;
  } else {
    strengthScore = 4;
  }

  return {
    rulesResults: rulesResults,
    strengthScore: strengthScore
  };
}

export default passwordAnalyzer;